<script lang="ts">
    import Card from "../UiCommenCard.svelte";
    import {  Col,Dropdown ,DropdownToggle,DropdownMenu,DropdownItem} from "sveltestrap";
    import { DropdownButton, DropdownWithDivider, href } from "../../../utils/Constant/Constant";
</script>
<Col sm="12" xl="6">
    <Card headerTitle={DropdownWithDivider} CardBodyprops="dropdown-basic" cardHeaderprops="pb-0" headerContent="Use a class">
      <div slot="contentbody">
        <Dropdown>
          <DropdownToggle color="primary" class="rounded-0">{DropdownButton}
              <span><i class="icofont icofont-arrow-down"></i></span>
          </DropdownToggle>
          <DropdownMenu>
              <DropdownItem href={href} >Link 1</DropdownItem>
              <DropdownItem divider></DropdownItem>
              <DropdownItem href={href} >Link 2</DropdownItem>
              <DropdownItem divider></DropdownItem>
              <DropdownItem href={href} >Link 3</DropdownItem>
              <DropdownItem divider></DropdownItem>
              <DropdownItem href={href} >Another Link</DropdownItem>
          </DropdownMenu>
      </Dropdown>
      </div>
    </Card>
</Col>